// Activé uniquement par df_cart_adapter. Une séquence pour adaptateurs puis tote ; aucun patch de fetch.
(() => {
  const initial = document.querySelector('[data-df-cart-state]');
  if (!initial || window.dfCartAdapter) return;
  const messages = JSON.parse(initial.textContent).messages;
  const root = Shopify.routes.root;
  let revision = 0;
  let running = null;
  let status = 'pending';
  let loading = 0;
  let replay = false;
  let lastError = null;
  let unknownGiftAdd = false;

  function paint() {
    document.querySelectorAll('form[action*="/cart"]').forEach((form) => {
      if (!form.querySelector('[name="checkout"]')) return;
      let box = form.querySelector('[data-df-adapter-status]');
      if (!box) {
        box = document.createElement('div');
        box.dataset.dfAdapterStatus = '';
        box.setAttribute('aria-live', 'polite');
        form.querySelector('[name="checkout"]').before(box);
      }
      box.replaceChildren();
      box.hidden = status === 'ready';
      if (status !== 'ready') {
        const text = document.createElement('p');
        text.className = 'text-sm';
        text.textContent = status === 'error' ? (lastError?.gift ? lastError.message : messages.error) : messages.pending;
        box.append(text);
        if (status === 'error') {
          const retry = document.createElement('button');
          retry.type = 'button';
          retry.className = 'link text-sm';
          retry.dataset.dfAdapterRetry = '';
          retry.textContent = messages.retry;
          box.append(retry);
        }
      }
      form.querySelectorAll('[name="checkout"]').forEach((button) => {
        button.setAttribute('aria-busy', String(status === 'pending'));
        button.setAttribute('aria-disabled', String(status !== 'ready'));
      });
    });
  }

  async function jsonFetch(url, options = {}) {
    const response = await fetch(url, { ...options, signal: AbortSignal.timeout(12000) });
    if (!response.ok) throw Object.assign(new Error('Cart request failed'), { status: response.status, rejected: response.status >= 400 && response.status < 500 });
    return response.json();
  }

  function sectionIds() {
    return ['df-cart-state', ...Array.from(document.querySelectorAll('[id^="shopify-section-"][id$="__cart-drawer"], .shopify-section--main-cart'))
      .map((node) => node.id.replace('shopify-section-', ''))];
  }

  async function read() {
    const url = new URL(location.pathname, location.origin);
    url.searchParams.set('sections', sectionIds().join(','));
    const sections = await jsonFetch(url, { cache: 'no-store' });
    if (Object.values(sections).some((html) => !html)) throw new Error('Cart section unavailable');
    const html = new DOMParser().parseFromString(sections['df-cart-state'], 'text/html');
    const state = JSON.parse(html.querySelector('[data-df-cart-state]').textContent);
    state.cart.sections = sections;
    return state;
  }

  function publish(state) {
    const main = document.querySelector('.shopify-section--main-cart');
    if (main) {
      const html = state.cart.sections[main.id.replace('shopify-section-', '')];
      const fresh = new DOMParser().parseFromString(html, 'text/html').getElementById(main.id);
      main.replaceChildren(...fresh.childNodes);
    }
    document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
      bubbles: true, detail: { baseEvent: 'df:benefits', cart: state.cart }
    }));
    paint();
  }

  const post = (path, body) => jsonFetch(`${root}${path}`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body)
  });

  const adding = () => loading || document.querySelector('product-form [type="submit"][aria-busy="true"], [data-df-quick-add][aria-busy="true"], [data-pdp-v3-quick-add][data-pdp-v3-busy="true"]');

  async function waitForAdds() {
    await window.dfCartActions?.wait();
    const start = Date.now();
    while (adding()) {
      if (Date.now() - start > 12000) throw new Error('Cart action still pending');
      await new Promise((resolve) => setTimeout(resolve, 50));
    }
  }

  async function reconcile() {
    let last = null;
    try {
      // Borné : une indisponibilité ou une autre app ne doit jamais créer une boucle d'ajouts.
      for (let attempt = 0; attempt < 12; attempt++) {
        await waitForAdds();
        const seen = revision;
        last = await read();
        if (seen !== revision || adding()) continue;
        const plan = window.dfCartBenefits.adapterPlan(last);
        if (plan.wanted && !plan.configured) throw new Error('Adapter not configured');
        if (plan.steps.length) {
          // Un pas = une ou deux requêtes dans l'ordre donné (ajout avant retrait), puis relecture du panier.
          for (const step of plan.steps) {
            if (step.add) await post('cart/add.js', { items: [step.add] });
            else await post('cart/change.js', step.change);
          }
          continue;
        }
        if (!plan.confirmed) throw new Error('Adapter discount not confirmed');

        // WEBLCFB2C-213 : la ligne « Personnalisation texte » suit sa coque (ajout, retrait, quantité 1).
        const perso = window.dfCartBenefits.persoPlan(last.cart.items);
        if (perso.erreur) throw new Error('Personalisation line not configured');
        if (perso.change) {
          await post('cart/change.js', perso.change);
          continue;
        }
        if (perso.add) {
          await post('cart/add.js', { items: [perso.add] });
          continue;
        }

        // Cadeaux voulus calculés par df-cart-tiers (paliers cumulatifs, conditions, stock) : un pas par requête.
        const wantedIds = (last.offer?.wanted || []).map(Number);
        const wantedCount = (id) => wantedIds.filter((wanted) => wanted === id).length;
        const gifts = last.cart.items.filter((item) => item.properties?._gift && item.variant_id !== Number(last.adapterVariant));
        const giftFailure = (flags = {}) => Object.assign(new Error(document.querySelector('cart-drawer')?.dataset[flags.unavailable ? 'dfGiftUnavailableText' : 'dfGiftErrorText'] || messages.error), { gift: true, ...flags });
        const missing = wantedIds.find((id) => !gifts.some((item) => item.variant_id === id));
        if (unknownGiftAdd && missing) throw giftFailure({ review: true });
        if (!missing) unknownGiftAdd = false;
        const seenVariants = new Set();
        const obsolete = gifts.find((item) => {
          const duplicate = seenVariants.has(item.variant_id);
          seenVariants.add(item.variant_id);
          return duplicate || !wantedCount(item.variant_id);
        });
        if (obsolete) {
          await post('cart/change.js', { id: obsolete.key, quantity: 0 });
          continue;
        }
        const wrong = gifts.find((item) => item.quantity !== wantedCount(item.variant_id));
        if (wrong) {
          await post('cart/change.js', { id: wrong.key, quantity: wantedCount(wrong.variant_id) });
          continue;
        }
        if (missing) {
          // Conserver la reprise du panier partagé : seul un refus confirmé permet
          // au client de choisir explicitement « Continuer sans le cadeau ».
          try {
            await post('cart/add.js', { items: [{ id: missing, quantity: wantedCount(missing), properties: { _gift: '1' } }] });
          } catch (error) {
            if (!error.rejected) unknownGiftAdd = true;
            last = await read();
            const after = last.cart.items.filter(item => item.properties?._gift && item.variant_id !== Number(last.adapterVariant));
            if (after.some(item => item.variant_id === missing)) { unknownGiftAdd = false; continue; }
            if (error.status === 422 && !after.some(item => item.variant_id === missing)) throw giftFailure({ unavailable: true });
            throw giftFailure({ review: unknownGiftAdd });
          }
          continue;
        }
        if (seen !== revision) continue;
        status = 'ready';
        publish(last);
        return true;
      }
      throw new Error('Cart did not settle');
    } catch (error) {
      lastError = error;
      status = 'error';
      if (last) publish(last);
      paint();
      return false;
    }
  }

  function ensure() {
    revision++;
    status = 'pending';
    paint();
    if (!running) running = (async () => {
      let started, ok;
      do {
        started = revision;
        ok = await reconcile();
      } while (started !== revision);
      running = null;
      return ok;
    })();
    return running;
  }
  window.dfCartAdapter = {
    ensure,
    isAutomatic: (item) => item.properties?._df_adapter === '1' && Number(item.variant_id || item.id) === Number(JSON.parse(initial.textContent).adapterVariant),
    async sync() {
      if (!await ensure()) throw (lastError?.gift ? lastError : Object.assign(new Error(messages.error), { gift: true, adapter: true }));
    }
  };

  document.addEventListener('theme:loading:start', () => { loading++; revision++; status = 'pending'; paint(); });
  document.addEventListener('theme:loading:end', () => { loading = Math.max(0, loading - 1); if (!loading) ensure(); });
  document.addEventListener('cart:change', (event) => {
    if (event.detail?.baseEvent !== 'df:benefits') ensure();
  });
  document.addEventListener('cart:refresh', ensure);
  document.addEventListener('cart-drawer:refreshed', paint);
  // Ces ajouts customs n'émettent pas theme:loading : couvrir aussi leur début, avant cart:change.
  window.addEventListener('click', (event) => {
    if (event.target.closest('[data-df-quick-add], [data-pdp-v3-quick-add]')) queueMicrotask(ensure);
  }, true);
  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-df-adapter-retry]')) { event.preventDefault(); ensure(); }
    const link = event.target.closest('a[href]');
    if (link && new URL(link.href).pathname.replace(/\/$/, '').endsWith('/checkout')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      ensure().then((ok) => { if (ok) location.assign(link.href); });
    }
  }, true);
  document.addEventListener('submit', (event) => {
    if (window.dfCartActions || replay || !event.target.matches('form[action*="/cart"]') || event.target.action.includes('/cart/add')) return;
    if (event.submitter && event.submitter.name !== 'checkout') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    // La synchronisation remplace le formulaire : reprendre un bouton fraîchement rendu.
    const main = Boolean(event.target.closest('.shopify-section--main-cart'));
    ensure().then((ok) => {
      if (!ok) return;
      const form = document.querySelector(main ? '.shopify-section--main-cart form.cart-page' : 'cart-drawer form.cart-drawer__footer');
      if (!form) return;
      replay = true;
      try { form.requestSubmit(form.querySelector('[name="checkout"]')); } finally { replay = false; }
    });
  }, true);
  window.addEventListener('pageshow', (event) => { if (event.persisted) ensure(); });
  ensure();
})();
